import PropTypes from 'prop-types';
import { SideNavBranch } from './side-nav-branch';
import { SideNavLeaf } from './side-nav-leaf';

export const SideNavItem = (props) => {
  const {
    active,
    children,
    depth = 0,
    disabled,
    external,
    icon,
    label,
    open: openProp,
    path,
    title,
  } = props;

  const offset = depth === 0 ? 0 : depth * 16;

  if (children) {
    return (
      <SideNavBranch
        depth={depth}
        icon={icon}
        disabled={disabled}
        openProp={openProp}
        offset={offset}
        active={active}
        title={title}
        path={path}
      >
        {children}
      </SideNavBranch>
    );
  }

  return (
    <SideNavLeaf
      depth={depth}
      icon={icon}
      disabled={disabled}
      offset={offset}
      active={active}
      title={title}
      external={external}
      label={label}
      path={path}
    />
  );
};

SideNavItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  depth: PropTypes.number,
  disabled: PropTypes.bool,
  external: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.node,
  open: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
};
